import React from 'react';
import { ComboboxOption } from '@headlessui/react';
import { Link } from 'gatsby';
import { SearchSelection } from '../molecules/SearchModalApplicationsTab';
import { clsx } from 'clsx';

interface IProps {
    path: string;
    children?: React.ReactNode;
    disableFocusStyling?: boolean;
}

export default function SearchModalComboboxOption(props: IProps) {
    const { path, children, disableFocusStyling = false } = props;

    return (
        <ComboboxOption
            as={Link}
            to={path}
            value={{ path } satisfies SearchSelection}
            className={clsx(
                'group block rounded-md hover:no-underline cursor-pointer select-none text-gray-900',
                disableFocusStyling ? '' : 'data-[focus]:bg-cyan-800 data-[focus]:text-white data-[focus]:outline-none',
            )}
            onMouseDown={(event) => {
                if (event.metaKey || event.ctrlKey || event.button === 1) {
                    // Prevent Combobox from selecting the item and closing the modal when opening in new tab/window
                    event.preventDefault();
                }
            }}
        >
            {children}
        </ComboboxOption>
    );
}
